import axios from "axios";
import { environment } from "../environment/environment";
import gatewayService from "@/services/gateway-service";


const analyicsService = {
    getCookie(cookieName) {
        let cookie = {};
        document.cookie.split(';').forEach(function(el) {
            let [key,value] = el.split('=');
            cookie[key.trim()] = value;
        })
        return cookie[cookieName];
    },

    sendEvento(event,document){
        // console.log('sendEvento '+document)
        let hashiId = window.localStorage.getItem("__hashiId__");
        let clientId = this.getCookie("_ga").slice(6)
        try{
            const requestBody = {
                api_id: environment.apiGatewayAnalytics,
                body: {
                    document:'71569669',
                    user_id:hashiId,
                    client_id: clientId,
                    user_properties: {
                        "user_id_dim": {
                            "value":  hashiId
                        }
                    },
                    events: [event]
                },
                product: "RUMBO"
            };
            return gatewayService.postApiGateway(requestBody)
        } catch (error) {
            console.error('Error', error);
        }
    },
}

export default analyicsService;